'use strict';

/**
 * Инициализация плагина Magnific Popup
 * @module
 * @see {@link http://dimsemenov.com/plugins/magnific-popup/documentation.html}
 */

// ----------------------------------------
// Imports
// ----------------------------------------

import 'magnific-popup';
import merge from 'lodash/merge';
import validation from './validation';
import horizontalScroll from './horizontal-scroll';
import wrapMedia from './wrap-media';
import phoneInput from './phone-input';
import animate from './animate';
import tabs from './tabs';
import swiperInput from './swiper';

// ----------------------------------------
// Private
// ----------------------------------------

// переводы для плагина
(function ($, jsTranslations = {}) {
	let {mfp} = jsTranslations;
	if (!mfp) {
		return false;
	}

	$.extend(true, $.magnificPopup.defaults, {
		tClose: mfp.tClose,
		tLoading: mfp.tLoading,
		gallery: {
			tPrev: mfp.tPrev,
			tNext: mfp.tNext,
			tCounter: mfp.tCounter
		},
		image: {
			tError: mfp.tErrorImage
		},
		ajax: {
			tError: mfp.tError
		},
		inline: {
			tNotFound: mfp.tNotFound
		}
	});
})(window.jQuery, window.jsTranslations);

// ----------------------------------------
// Public
// ----------------------------------------

/**
 * @param {string} [selector=".js-form"]- поиск элементов по селектору
 * @param {Object} [userConfig={}] - пользовательский конфиг
 * @param {jQuery} [$wrapper=$('body')] - контекст в котором будет выполнен поиск селектора
 * @sourceCode
 */
function mfpAjax (selector = '.js-mfp-ajax', userConfig = {}, $wrapper = $('body')) {
	const config = merge({
		mainClass: 'zoom-in',
		type: 'ajax',
		delegate: selector,
		removalDelay: 200,
		autoFocusLast: false,
		fixedContentPos: false,
		closeOnBgClick: false,
		callbacks: {
			elementParse (item) {
				let {
					url,
					type = 'POST',
					param: data = {}
				} = item.el.data();
				this.st.ajax.settings = {url, type, data};
			},
			ajaxContentAdded () {
				let _this = this;
				let $container = this.contentContainer || [];
				if ($container) {
					horizontalScroll('.wysiwyg table', $container);
					wrapMedia('.wysiwyg iframe, .wysiwyg video', $container);
					validation('.js-form', $container);
					phoneInput($container);
					animate($container);
					tabs($container);
					swiperInput();
				}

				if (typeof this.currItem.el.data('order-name') !== 'undefined') {
					$container.find('.js-order-name').html(this.currItem.el.data('order-name'));
				}

				let setNumber = $('.js-set-number');

				$(".attachment__input").change(function(){
					let filename = $(this).val().replace(/.*\\/, "");
					if (!filename.length) {
						$(".attachmen__text").html('Add an attachment');
					} else {
						$(".attachmen__text").html(filename);
					}
				});

				if (setNumber.length) {
					let number = $('#get-number').text();
					setNumber.text(number);
					number = number.replace(/ /g, '');
					setNumber.attr('href', 'tel:+38' + number);
				}

				$(_this.wrap).on('mousedown', function (e) {
					_this.st.closeOnBgClick = true;
					if (_this._checkIfClose(e.target)) {
						_this.close();
					}
					_this.st.closeOnBgClick = false;
				});
			}
		}
	}, userConfig);

	$wrapper.magnificPopup(config);
}

function mfpIframe (selector = '.js-mfp-iframe', userConfig = {}) {
	const config = merge({
		mainClass: 'zoom-in',
		type: 'iframe',
		closeBtnInside: true,
		autoFocusLast: false,
		fixedContentPos: false,
		removalDelay: 200,
		iframe: {
			markup: '<div class="magnific-popup mfp-iframe-scaler">' +
			'<div class="mfp-close"></div>' +
			'<iframe class="mfp-iframe" frameborder="0" allowfullscreen></iframe>' +
			'</div>',
			patterns: {
				youtube: {
					index: 'youtube.com/',
					id: 'v=',
					src: '//www.youtube.com/embed/%id%?rel=0&autoplay=1&showinfo=0'
				}
			}
		}
	}, userConfig);

	$(selector).magnificPopup(config);
}

function mfpImage (selector = '.js-mfp-image', userConfig = {}) {
	const config = merge({
		mainClass: 'zoom-in',
		type: 'image',
		closeBtnInside: true,
		autoFocusLast: false,
		fixedContentPos: false,
		removalDelay: 200
	}, userConfig);

	$(selector).magnificPopup(config);
}

function mfpWysiwyg (selector = '.wysiwyg', userConfig = {}) {
	const config = merge({
		mainClass: 'zoom-in',
		type: 'image',
		delegate: '[target="_mfp"]',
		closeBtnInside: true,
		autoFocusLast: false,
		fixedContentPos: false,
		removalDelay: 200
	}, userConfig);

	$(selector).magnificPopup(config);
}

// ----------------------------------------
// Exports
// ----------------------------------------

export { mfpAjax, mfpIframe, mfpImage, mfpWysiwyg };



// WEBPACK FOOTER //
// ./src/js/_modules/magnific-popup.js